"use strict";

import menu from './modules/menu.mjs';
import magnificPopup from "./modules/magnific-popup.mjs";
import loading from './modules/loading.mjs';
import animations from './modules/animations.mjs';
import tcNeosElementsBootstrap from 'tc-neos-elements-bootstrap';
import tcNeosElements from 'tc-neos-elements'; // do not remove this line, even if it is not used (Google Maps call initMap() from this file)
import bannerVideo from './modules/banner-video.mjs';
import footerNavigation from './modules/footer-navigation.mjs';
import {Tooltip} from 'bootstrap';
import dlGallery from "./modules/dl-gallery.mjs";
import flightBooking from "./modules/flight-booking.mjs";

$(document).ready(() => {
    const isBackend = $('body').hasClass('neos-backend')

    const languageRedirection = () => {
        if (document.cookie.includes('lang_redirect_done=1')) return;

        if (window.location.pathname.startsWith('/en') || window.location.pathname.startsWith('/de')) {
            document.cookie = 'lang_redirect_done=1; path=/; max-age=' + (60 * 60 * 24);// 1 day
        }
    }

    loading.init()
    if (window.innerWidth > 991) {
        menu.buildDesktopMenu()
    }
    tcNeosElementsBootstrap.anchor()
    window.addEventListener('hashchange', () => {
        tcNeosElementsBootstrap.anchor()
    })

    bannerVideo.init()
    footerNavigation.init()
    dlGallery.init()

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    });

    if (!isBackend) {
        languageRedirection()
        magnificPopup.init()
        animations.init()
        flightBooking.init()

        if (window.innerWidth < 768) {
            menu.buildMobileMenu()
        }
    }

    const reservationResumeDocument = document.querySelector('body.tc-website-reservationresume-document');
    if (reservationResumeDocument) {
        document.getElementById('introduction-checkout-button').addEventListener('click', () => {
            const paymentButton = reservationResumeDocument.querySelector('.payment-button > a');
            window.location.href = paymentButton.attributes.href.value;
        });
    }
});
